export default {
    data: [
        'Đất trống',
        'Nhà cấp 4',
        '1 trệt 1 lầu',
        '1 trệt 2 lầu',
        '1 trệt 3 lầu',
        'Nhà trên 3 lầu',
        'Chung cư',
        'Biệt thự',
        'Nhà kho',
        'Nhà trọ',
        'Nhà khác'
    ]
}